import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { Card } from "antd";
import styled, { css } from "styled-components";

export const StyledAppCard = styled(Card)<AppCardProps>`
  // box-shadow: ${({ theme }) => theme.cardShadow} !important;
  border-radius: ${({ theme }) => theme.cardRadius} !important;
  background: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  border-color: ${({ theme }) => theme.palette.borderPrimaryColor};

  ${({ borderHeader }) =>
    borderHeader &&
    css`
      & > .ant-card-head {
        border: 1px dashed ${({ theme }) => theme.palette.borderColor};
      }
    `}

  ${({ coloredHeader }) =>
    coloredHeader &&
    css`
      & > .ant-card-head {
        background-color: ${({ theme }) => theme.palette.background.secondary};
      }
    `}

  ${({ borderFull }) =>
    borderFull &&
    css`
      border: 1px dashed ${({ theme }) => theme.palette.borderColor};
    `}

  & .ant-card-head-title {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  & > .ant-card-head {
    min-height: 10px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding: 5px 10px;
    border-bottom: 0 none;
    margin-bottom: 0;
    border-radius: unset;

    & .ant-card-head-title {
      line-height: 1.4993rem;
      padding: 0;
    }

    & .ant-card-extra {
      padding: 0;

      & a {
        color: ${({ theme }) => theme.palette.secondary.main};
      }
    }
  }

  & > .ant-card-body {
    // padding: 8px;

    .collapse-content {
      transition:
        max-height 0.3s ease-in-out,
        opacity 0.3s ease-in-out;
      max-height: 5000px;
      overflow: hidden;
      opacity: 1;

      &.collapse-content-collapsed {
        max-height: 0;
        opacity: 0;
      }
    }
  }

  &.heightFull {
    height: 100%;

    & .ant-card-body {
      flex: 1;
    }
  }

  & .ant-card-actions {
    background-color: transparent;
    // padding-top: 16px !important;
  }

  &.no-card-space {
    & .ant-card-body {
      padding: 0;
    }
  }

  &.no-card-space-ltr-rtl {
    & .ant-card-body {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
